import {URL} from './api';
import axios from 'axios';
import {parseStorage} from './functions'
import {helpBarAction} from './helpbarAction'

export const CONTACT__DATA = 'CONTACT__DATA' 

export function contactAction(data){
    return dispatch => {        
        dispatch({
            type: CONTACT__DATA,
            data: 'sending'
        })
        axios.post(URL + `/guest/contact`,data,{
            headers: {
                'Accept' : 'application/json',
                'Content-Type': 'application/json'
            }
        }).then(function(res){               
            dispatch({
                type: CONTACT__DATA,
                data: 'success'
            })                     
        }).catch(function(err){
            
            dispatch({
                type: CONTACT__DATA,
                data: 'error'
            })         
        })
    }
}


// WEBPACK FOOTER //
// ./src/actions/contactAction.js